import { useEffect } from "react";

/** Sélecteur de toute modale Le Desk : overlays maison (data-desk-modal / fixed inset-0) + dialogs Radix ouverts. */
const MODAL_SELECTOR = '[data-desk-modal], [role="dialog"][data-state="open"], div.fixed.inset-0:not([data-no-scroll-lock])';
export const openModalCount = () => document.querySelectorAll(MODAL_SELECTOR).length;

let scrollbarW = 0;
const apply = () => {
  const body = document.body;
  const locked = openModalCount() > 0;
  if (locked && body.dataset.scrollLocked !== "1") {
    scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    body.dataset.scrollLocked = "1";
    body.style.overflow = "hidden";
    if (scrollbarW > 0) body.style.paddingRight = `${scrollbarW}px`;
  } else if (!locked && body.dataset.scrollLocked === "1") {
    delete body.dataset.scrollLocked;
    body.style.overflow = "";
    body.style.paddingRight = "";
  }
};

/** Bloque le défilement de la page tant qu'au moins une modale est ouverte (compteur DOM, modales imbriquées gérées), compense la scrollbar. */
export default function ScrollLockObserver() {
  useEffect(() => {
    const obs = new MutationObserver(() => requestAnimationFrame(apply));
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-state", "class", "data-desk-modal"] });
    apply();
    return () => { obs.disconnect(); delete document.body.dataset.scrollLocked; document.body.style.overflow = ""; document.body.style.paddingRight = ""; };
  }, []);
  return null;
}
